import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import TopicList from './components/TopicList';


function TopicListing() {

    const { page } = useParams();

    const styles = {
        page:{
            paddingTop: 40,
            paddingBottom: 100
        },
        header:{
            paddingBottom: 10,
            display: 'flex',
            alignItems: 'center'
        },
        title: {
            color: '#666',
            fontSize: 18
        },
    }

    return (
        <div style={styles.page}>
        <div className='container'>
            <div className='row'>
                <div className='col-md-8'>

                    <div style={styles.header}>
                        <h4 style={styles.title}>Topic Listing</h4>
                    </div>
                    
                    <TopicList category={""} page={page} />

                </div>
                <div className='col-md-3'></div>
            </div>
        </div>
        </div>
    )
    
}

export default TopicListing;